import { Navigate, useLocation, Link } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import Spinner from '../components/common/Spinner';

/**
 * Requires authentication. Redirects to /login if not.
 */
export const ProtectedRoute = ({ children }) => {
  const { isAuthenticated, loading } = useAuth();
  const location = useLocation();

  if (loading) return <Spinner />;

  if (!isAuthenticated) {
    return <Navigate to="/home" state={{ from: location }} replace />;
  }

  return children;
};

/**
 * Requires specific roles. Shows 403 if unauthorized.
 */
export const RoleRoute = ({ roles, children }) => {
  const { user, loading } = useAuth();

  if (loading) return <Spinner />;

  if (!user || !roles.includes(user.role)) {
    return (
      <div className="text-center py-5">
        <i className="bi bi-shield-lock" style={{ fontSize: '4rem', color: '#CBD5E0' }}></i>
        <h3 className="mt-3" style={{ color: '#1B3A5C' }}>Access Denied</h3>
        <p className="text-muted">You don't have permission to view this page.</p>
        <Link to="/app/dashboard" className="btn btn-primary mt-2">Go to Dashboard</Link>
      </div>
    );
  }

  return children;
};

/**
 * Guest-only route (login page). Redirects to dashboard if already authenticated.
 */
export const GuestRoute = ({ children }) => {
  const { isAuthenticated, loading } = useAuth();

  if (loading) return <Spinner />;

  if (isAuthenticated) {
    return <Navigate to="/app/dashboard" replace />;
  }

  return children;
};
